function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "LO");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0,2.1h20v49.6h30.3v17.6H0V2.1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.4,0c-19.9,0-36,16.1-36,36s16.1,36,36,36s36-16.1,36-36S106.3,0,86.4,0z M99.5,44.6     c-1.2,2.4-3.1,4.4-5.4,5.9c-4.7,2.7-10.6,2.7-15.3,0c-2.3-1.4-4.2-3.4-5.4-5.9c-1.4-2.7-2.1-5.8-2-8.9c-0.1-3.1,0.6-6.1,2-8.9     c1.2-2.4,3.1-4.4,5.4-5.8c4.7-2.8,10.6-2.8,15.3,0c2.3,1.4,4.2,3.4,5.4,5.9c1.4,2.7,2.1,5.8,2,8.9C101.6,38.8,100.9,41.9,99.5,44.6z   "
});

var SvgLoLogo = function SvgLoLogo(props) {
  return React.createElement("svg", _extends({
    id: "LO",
    viewBox: "0 0 123 72",
    style: {
      enableBackground: "new 0 0 123 72"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnCiAgdmVyc2lvbj0iMS4xIgogIGlkPSJMTyIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCiAgdmlld0JveD0iMCAwIDEyMyA3MiIKICBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMjMgNzI7IgogIHhtbDpzcGFjZT0icHJlc2VydmUiCj4KICA8dGl0bGU+TE88L3RpdGxlPgogIDxwYXRoIGQ9Ik0wLDIuMWgyMHY0OS42aDMwLjN2MTcuNkgwVjIuMXoiLz4KICA8cGF0aCBkPSJNODYuNCwwYy0xOS45LDAtMzYsMTYuMS0zNiwzNnMxNi4xLDM2LDM2LDM2czM2LTE2LjEsMzYtMzZTMTA2LjMsMCw4Ni40LDB6IE05OS41LDQ0LjYKICAgIGMtMS4yLDIuNC0zLjEsNC40LTUuNCw1LjljLTQuNywyLjctMTAuNiwyLjctMTUuMywwYy0yLjMtMS40LTQuMi0zLjQtNS40LTUuOWMtMS40LTIuNy0yLjEtNS44LTItOC45Yy0wLjEtMy4xLDAuNi02LjEsMi04LjkKICAgIGMxLjItMi40LDMuMS00LjQsNS40LTUuOGM0LjctMi44LDEwLjYtMi44LDE1LjMsMGMyLjMsMS40LDQuMiwzLjQsNS40LDUuOWMxLjQsMi43LDIuMSw1LjgsMiw4LjlDMTAxLjYsMzguOCwxMDAuOSw0MS45LDk5LjUsNDQuNnoKICAiLz4KPC9zdmc+Cg==";
export { SvgLoLogo as ReactComponent };